import { render } from "./ScrollTopComponent.vue?vue&type=template&id=02d4dd3f&scoped=true"
import script from "./ScrollTopComponent.vue?vue&type=script&lang=js"
export * from "./ScrollTopComponent.vue?vue&type=script&lang=js"

import "./ScrollTopComponent.vue?vue&type=style&index=0&id=02d4dd3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d4dd3f"]])

export default __exports__